// extracted by mini-css-extract-plugin
export var printerCard = "_im-1";
export var printerCardConfigured = "_im-2";
export var printerCardError = "_im-3";
export var printerCardsContainer = "_im-0";
export var printerIcon = "_im-8";
export var printerIconConfigured = "_im-5";
export var printerIconContainer = "_im-4";
export var printerIconError = "_im-6";
export var printerIconUnconfigured = "_im-7";
export var workstationsTableCard = "_im-9";